import { WeekDaySelector } from './WeekDaySelector'
import { TimeSelect } from '../../common/TimeSelect'
import { Box, Button, Flex } from '@chakra-ui/react'
import { useState } from 'react'
import TimezoneSelect from 'react-timezone-select'
import { customStyles } from '../../common/Select'

const getActiveDays = (schedule) => schedule.dayOfWeekList.map((day) => day['@DayOfWeek'])
const getStartTime = (schedule) => schedule.startTime['@Time']
const getStopTime = (schedule) => schedule.endTime['@Time']

export const DailyInterval = ({ schedule, onSave }) => {
    const [activeDays, setActiveDays] = useState(schedule ? getActiveDays(schedule) : [])
    const [startTime, setStartTime] = useState(schedule ? getStartTime(schedule) : '00:00')
    const [stopTime, setStopTime] = useState(schedule ? getStopTime(schedule) : '00:00')
    const [selectedTimezone, setSelectedTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)

    const onTimeZoneChange = (timeZone) => {
        setSelectedTimezone(timeZone.value)
    }

    const handleSave = () => {
        const scheduleMockup = {
            '@StandardSessionScheduleCfg': {
                dayOfWeekList: activeDays.map((day) => ({ '@DayOfWeek': day })),
                startTime: {
                    '@Time': startTime
                },
                endTime: {
                    '@Time': stopTime
                },
                timeZoneId: selectedTimezone
            }
        }
        console.log('save with mockup', scheduleMockup)
        onSave(scheduleMockup)
    }

    return (
        <Box display="flex" flexDir="column" alignItems="center" justifyContent="center">
            <WeekDaySelector multiDay onChange={setActiveDays} selectedDays={activeDays} />
            <Flex marginY={4} justifyContent="center">
                <TimeSelect type="From:" value={startTime} onChange={setStartTime} mr={4} />
                <TimeSelect type="To:" value={stopTime} onChange={setStopTime} />
            </Flex>
            <TimezoneSelect width="600px" styles={customStyles} value={selectedTimezone} onChange={onTimeZoneChange} />
            <Button
                width="fit-content"
                mt={4}
                onClick={handleSave}
                isDisabled={activeDays.length === 0}
            >
                ADD
            </Button>
        </Box>
    )
}
